export default {
  "box-name": "en-style2",
  "public-btn-text": "Register Now",
  "screen0": {
    "title": "EBC Provides A Truly Top-Tier<br>Global Liquidity For Investors",
    "enTitle": "<text style='color:#6c100f;font-family: 'Source Serif Pro', Georgia, 'Times New Roman', serif;'>EBC THE FUTURE</text>",
    "list": [{
        "title": "Safety",
        "desc": "Connecting to Equinix centres worldwide through the optical fibre dedicated line of peer-to-peer networking to achieve an extremely fast order execution as low as 20 milliseconds."
      },
      {
        "title": "Compliance",
        "desc": "All client funds are held in segregated independent trust accounts with top-tier banks and are subject to strict regulation."
      },
      {
        "title": "Liquidity",
        "desc": "EBC has established long-term and stable cooperative relationships with the world's leading international banks, allowing you to make trading easily at ultra-low costs."
      }
    ]
  },
  "screen1": {
    title: 'Liquidity Depth',
    "trList": [
      "hierarchy",
      "buying price",
      "trading volume bought ",
      "point difference",
      "selling price ",
      "selling price volume "
    ],
    "mobileTrList": [
      "hierarchy",
      "buying price",
      "point difference",
      "selling price "
    ]
  },
  "screen2": {
    "pageEnTitle": "EBC Clearing Ecosystem",
    "pageTitle": "EBC Clearing Ecosystem",
    "title": "EBC has a safe, transparent and credible clearing ecosystem"
  },
  "screen3": {
    "pageEnTitle": "Private Room Trading Space",
    "pageTitle": "Private Room Trading Space",
    "title": "There is no unified clearing standard, so all possibilities must be taken into consideration.",
    "desc": 'If you are a "large-scale trader" and prefer not to disclose your "large orders" to others, the EBC Private Room will be your optimal choice.'
  },
  "screen4": {
    "title": "Take control of your exclusive liquidity and easily grasp global markets",
    "desc": "Private Room can hide part of your transaction information, which means that your “large order” may be filled at a better price without serious slippage or rejection due to Last Look. As shown in the figure above, the large orders traded through Private Room are filled at more favorable prices than anticipated."
  },
  "screen5": {
    "it": "Only time, let you know me better",
    "ct": "* there may be slippage, delay and various uncertain factors in the transaction. Maybe you will not notice these details from senior traders, but if you have any inconvenience, please give us feedback in time. EBC advocates high quality and geek spirit, and actively embraces the uncertain future. Strive to bring customers a minimalist, pure and comfortable new trading experience.",
    "title": "Meeting and exceeding your expectations",
    "desc": "We will actively listen to your feedback and attach great importance to enhancing your personalized trading experience. EBC development team has always been committed to the R&D and improvement of new functions and technologies to further optimize our customers’ online trading experience. ",
    "btn": "Explore our advantages"
  }
}
